<template>
  <div class="section">
    <div class="transaction__filter--container d-block bg-white py-2">
      <b-row class="search__export align-items-center mx-0">
        <b-col cols="6" md="6" lg="5">
          <div class="d-flex pl-2">
            <b-img class="filter-image" :class="filter.sort_type == 'asc' ? 'rotate-180' : ''"
              :src="require('@/assets/images/icons/Icon-order-list-down.svg')" alt="Icon-order-list-down" role="button"
              @click="
                filter.sort_type == 'asc'
                  ? (filter.sort_type = 'desc')
                  : (filter.sort_type = 'asc')
                " />
            <div class="search__input w-100 pl-2 pr-0 mr-0">
              <b-input-group>
                <b-form-input v-model="filter.search" placeholder="Cari Billing" />
                <b-input-group-append is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </b-col>
        <b-col cols="6" md="6" lg="7">
          <div class="d-flex justify-content-end" style="gap: 5px">
            <b-button class="py-1 border-8 font-small-3" @click="extendMainStoreSubscription" v-if="isMainAccount">
              Perpanjang Toko Utama
            </b-button>
            <b-button class="py-1 border-8 font-small-3" @click="addOrExtend('branch')">
              Tambah/Perpanjang Cabang
            </b-button>
            <b-button class="py-1 border-8 font-small-3" @click="addOrExtend('user')">
              Tambah/Perpanjang Pengguna
            </b-button>
            <!-- <b-button class="py-1 border-8 font-small-3" @click="$bvModal.show('modal-billing-subscription')">
              Tambah Masa Aktif Pengguna
            </b-button>
            <b-button class="py-1 border-8 font-small-3" @click="$bvModal.show('modal-billing-subscription')">
              Tambah Masa Aktif Cabang
            </b-button> -->
          </div>
        </b-col>
      </b-row>
    </div>

    <vue-good-table v-if="items" max-height="80vh" :columns="columns" :rows="items" :fixed-header="false" :sort-options="{
      enabled: false
    }" :pagination-options="{
      enabled: false,
    }">
      <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field == 'action'" />
      </template>
      <template slot="table-row" slot-scope="props">
        <!-- Column: Status -->
        <span v-if="props.column.field === 'payment_status'">
          <span :class="{
            'badge badge-light-success': props.row.payment_status === 'success',
            'badge badge-light-warning': props.row.payment_status === 'pending',
            'badge badge-light-danger': props.row.payment_status === 'canceled',
            'badge badge-light-secondary': props.row.payment_status === 'expired',
          }">
            {{
              props.row.payment_status === 'success' ? 'Sukses' :
                props.row.payment_status === 'pending' ? 'Menunggu Pembayaran' :
                  props.row.payment_status === 'canceled' ? 'Dibatalkan' : 'Kedaluwarsa'
            }}
          </span>
        </span>

        <!-- Column Price -->
        <span v-else-if="props.column.field === 'subscription_renewal.sell_price'">
          <span>{{
            props.row.subscription_renewal && props.row.subscription_renewal.sell_price | formatAmount
          }}</span>
        </span>

        <!-- Column: Metode Bayar -->
        <span v-else-if="props.column.field === 'payment_method'">
          <span>
            {{
              props.row.payment_method === "qr_code"
                ? "QRIS"
                : props.row.payment_method === "bca_va"
                  ? "BCA Virtual Account"
                  : props.row.payment_method === "bjb_va"
                    ? "BJB Virtual Account"
                    : props.row.payment_method === "bni_va"
                      ? "BNI Virtual Account"
                      : props.row.payment_method === "bri_va"
                        ? "BRI Virtual Account"
                        : props.row.payment_method === "bsi_va"
                          ? "BSI Virtual Account"
                          : props.row.payment_method === "cimb_va"
                            ? "CIMB Virtual Account"
                            : props.row.payment_method === "permata_va"
                              ? "PERMATA Virtual Account"
                              : "MANDIRI Virtual Account"
            }}
          </span>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown id="dropdown-dropleft" class="d-flex" right>
              <template #button-content class="btn-white text-center">
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle" />
              </template>
              <b-dropdown-item @click="detailItem(props.row)">
                <span class="pr-5"> Detail Data </span>
              </b-dropdown-item>
              <b-dropdown-item v-if="props.row.payment_status === 'pending'" @click="cancelOrder(props.row.uuid)">
                <span class="pr-5"> Batalkan Transaksi </span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>

    <div v-if="rows && isLoading == false"
      class="d-flex justify-content-between align-items-center flex-wrap bg-white border" style="padding: 0.8rem">
      <div class="d-flex align-items-center">
        <b-form-select v-model="filter.per_page" :options="['10', '15', '20']" class="mx-1" />
        <span class="text-nowrap">
          Tampilkan
          {{
            rows.data && rows.data.total > 0
              ? filter.per_page * (rows.data.current_page - 1) + 1
              : 0
          }}
          ke
          {{
            rows.data && rows.data.total > 0
              ? Math.min(
                filter.per_page * rows.data.current_page,
                rows.data.total
              )
              : 0
          }}
          dari {{ rows.data && rows.data.total }} transaksi.
        </span>
      </div>
      <div>
        <b-row class="mx-0 align-items-center">
          <b-col>
            <pagination class="mb-0" :data="rows.data" :limit="4" align="right"
              @pagination-change-page="getListSubscription" />
          </b-col>
        </b-row>
      </div>
    </div>

    <ModalSubscribe :subscriptionCredit="subscriptionCredit" :renewalStatus="(creditSubscriptionPayload.receiver_uuid && creditSubscriptionPayload.receiver_uuid.renewal_status) || renewalStatus" :renewalEndDate="(creditSubscriptionPayload.receiver_uuid && creditSubscriptionPayload.receiver_uuid.renewal_end_date) || renewalEndDate" :subscriptionMethod="subscriptionMethod" />
    <ModalBillingSubcription :typeExtend="typeExtend" :clearCreditProperty="clearCreditProperty" :subscriptionCredit="subscriptionCredit" :renewalStatus="creditSubscriptionPayload.receiver_uuid && creditSubscriptionPayload.receiver_uuid.renewal_status" :renewalEndDate="creditSubscriptionPayload.receiver_uuid && creditSubscriptionPayload.receiver_uuid.renewal_end_date" :subscriptionMethod="subscriptionMethod" />

    <b-modal
      id="modal-subscription-method"
      centered
      hide-header
      hide-footer
    >
      <div class="text-center mt-2 mb-4">
        <span class="text-dark text-center font-weight-bolder size23">Pilih Metode Berlangganan Kamu</span>
      </div>
      <div class="d-flex justify-content-center align-items-center mb-2" style="gap: 1rem">
        <b-button
          v-b-tooltip.hover.bottom="'Bayar di muka untuk 3, 6, atau 12 bulan. Biaya Tetap, Fitur Lengkap!'"
          :variant="'outline-dark'"
          class="d-flex justify-content-center align-items-center size16"
          style="gap: 1rem"
          @click="submit('fix_plan')"
        >
          <img width="42" src="@/assets/images/icons/income.svg" alt="toqoo fix plan">
          <span>Toqoo Fix Plan</span>
        </b-button>
        <b-button
          v-b-tooltip.hover.bottom="'Bayar Sesuai Pemakaian, Tanpa beban bulanan Fitur lengkap, biaya tetap ringan!'"
          :variant="'outline-dark'"
          class="d-flex justify-content-center align-items-center size16"
          style="gap: 1rem"
          @click="submit('flex_plan')"
        >
          <img width="42" src="@/assets/images/icons/user-renewal.svg" alt="toqoo flex plan">
          <span>Toqoo Flex Plan</span>
        </b-button>
      </div>

      <!-- <template #modal-footer="{}">
        <b-button @click="submit" :disabled="!subscriptionMethod">
          Simpan
        </b-button>
      </template> -->
    </b-modal>

    <b-modal
      id="modal-detail-information"
      hide-header
      hide-footer
      size="lg"
      modal-class="custom__modal--large"
    >
      <ModalHeader
        :left-text="'Kembali'"
        :middle-text="titleDetailInformation[subscriptionMethod]"
        :is-rigt-column="true"
        :right-text="'Bayar'"
        :right-function="submitSubscriptionMethod"
        :left-function="prevSubmitSubscriptionMethod"
        :isDisabled="isLoading || disabledSubmitIfMinimumTopupIsLessThanTotalCredit"
      />

      <div class="mt-10">
        <b-row class="justify-content-center mb-1" v-if="typeExtend == 'branch'">
          <b-col cols="12" md="6">
            <b-form-group class="custom__form--input mb-0">
              <label for="v-branch">Cabang</label>
              <v-select
                id="v-branch"
                v-model="creditSubscriptionPayload.receiver_uuid"
                placeholder="Pilih Cabang"
                class="custom__input"
                :options="optionsBranch"
                label="name"
                @search="onSearchBranch"
              >
                <template v-slot:option="option">
                  <span :class="option.icon"></span>
                  {{ option.name }} 
                    <span v-if="option.renewal_status !== 'subscribe-flex-plan'">({{ option.renewal_end_date | formatDateWithTime }})</span>
                    <span v-if="option.renewal_status === 'subscribe-flex-plan'">(Credit: {{ option.subscription_credit | formatInvoice }})</span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="justify-content-center mb-1">
          <b-col cols="12" md="6">
              <b-form-group class="custom__form--input mb-0">
                <label for="topup-credit">Topup Credit <span class="text-danger">(Minimal Topup: Rp {{ minimumTopupCredit | formatInvoice }})</span></label>
                <money id="topup-credit" v-bind="money" v-model="creditSubscriptionPayload.amount" :placeholder="`Minimal Topup: ${minimumTopupCredit}`" class="custom__input border-8 pl-1 w-100" />
              </b-form-group>
              <span class="text-dark size12 font-weight-bolder">Harga Satuan Kredit: {{ transactionFee | formatInvoice }}</span> <br />
              <span class="text-dark size12 font-weight-bolder">Saldo Credit Tersedia: {{ creditSubscriptionPayload.receiver_uuid && creditSubscriptionPayload.receiver_uuid.renewal_status === 'subscribe-flex-plan' ? creditSubscriptionPayload.receiver_uuid.subscription_credit : renewalStatus === 'subscribe-flex-plan' && creditSubscriptionPayload.receiver_uuid === '' ? subscriptionCredit : 0 | formatInvoice}}</span>
              <!-- {{ subscriptionCredit | formatInvoice}} -->
              <ul>
                <li>1 Transaksi Penjualan = 1 Credit</li>
                <li>1 Credit = Rp {{ parseFloat(transactionFee) | formatInvoice }}</li>
              </ul>
          </b-col>
        </b-row>

        <b-row class="justify-content-center">
          <b-col cols="12" md="6">
            <b-form-group class="custom__form--input">
              <label for="payment">Pilih Metode Pembayaran</label>
              <v-select id="payment" v-model="creditSubscriptionPayload.payment_method" label="name" :options="paymentList"
                :reduce="(paymentList) => paymentList.value" placeholder="Pilih Metode Pembayaran">
                <template #selected-option="{ image, name }">
                    <div class="d-flex align-items-center" style="gap: 6px">
                      <img :src="image" :alt="name"
                        style="width: 30px" />
                      <p class="size12 mb-0">{{ name }}</p>
                    </div>
                  </template>
                  <template #option="{ image, name }">
                    <div class="d-flex align-items-center" style="gap: 8px">
                      <img :src="image" :alt="name"
                        style="width: 30px" />
                      <p class="mb-0">{{ name }}</p>
                    </div>
                  </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="justify-content-center">
          <b-col cols="12" md="6">
            <div class="mt-1">
              <span class="text-dark size18 font-weight-bolder">Total Tagihan: {{ creditSubscriptionPayload.amount | formatAmount }}</span>
              <!-- <b-alert
                variant="success"
                show
                class="mt-2"
              >
                <div class="alert-body">
                  <span>Total credit yang didapat setelah transaksi selesai: {{ creditSubscriptionPayload.amount / parseFloat(this.transactionFee) | formatInvoice }} Credit.</span>
                </div>
              </b-alert> -->
              <div class="mt-2">
                <b-alert v-if="creditSubscriptionPayload.amount > 0 && creditSubscriptionPayload.amount < minimumTopupCredit" 
                        variant="danger" show>
                  <div class="alert-body">
                    Minimal Topup adalah Rp {{ minimumTopupCredit | formatInvoice }}
                  </div>
                </b-alert>

                <b-alert v-else-if="creditSubscriptionPayload.amount > 0 && creditSubscriptionPayload.amount % parseFloat(transactionFee) !== 0" 
                        variant="warning" show>
                  <div class="alert-body">
                    Jumlah harus kelipatan harga 1 kredit (Rp {{ transactionFee | formatInvoice }})
                  </div>
                </b-alert>

                <b-alert v-else-if="!disabledSubmitIfMinimumTopupIsLessThanTotalCredit && creditSubscriptionPayload.amount > 0" 
                        variant="success" show>
                  <div class="alert-body">
                    Total credit yang didapat: {{ creditSubscriptionPayload.amount / parseFloat(this.transactionFee) | formatInvoice }} Credit.
                  </div>
                </b-alert>
              </div>
            </div>
          </b-col>
        </b-row>

      </div>
    </b-modal>

  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import {
  BRow, BCol, BFormSelect, VBToggle, BFormInput, BInputGroup, BInputGroupAppend, BImg, BButton, BDropdown, BDropdownItem, BSpinner, BModal, VBTooltip, BFormGroup, BAlert
} from 'bootstrap-vue'
import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
import ModalSubscribe from '../Master/Toko/Modal/ModalSubscribe.vue'
import ModalBillingSubcription from './ModalBillingSubcription.vue'

import { VueGoodTable } from 'vue-good-table'
import ModalHeader from '@/components/ModalHeader.vue';
import vSelect from "vue-select";
import { clear } from 'echarts/lib/util/throttle'

export default {
  components: {
    VueGoodTable,
    BFormSelect,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BButton,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    ModalSubscribe,
    BSpinner,
    ModalBillingSubcription,
    BModal,
    ModalHeader,
    vSelect,
    BFormGroup,
    BAlert
  },
  directives: {
    "b-toggle": VBToggle,
    'b-tooltip': VBTooltip,
  },
  setup() {
    return {
      checkPermission,
      successNotification,
      errorNotification,
    };
  },
  computed: {
    disabledSubmitIfMinimumTopupIsLessThanTotalCredit() {
    const amount = this.creditSubscriptionPayload.amount;
    const fee = parseFloat(this.transactionFee);

    // 1. Must be greater than or equal to minimum
    const meetsMinimum = amount >= this.minimumTopupCredit;
    
    // 2. Must be a multiple of the transaction fee (1 credit price)
    // We use a small epsilon check for floating point math if necessary, 
    // but for IDR (integers), a simple % is usually fine.
    const isMultiple = amount % fee === 0;

    // Disable button if either condition is false (or amount is 0)
    return !meetsMinimum || !isMultiple || amount <= 0;
    }
  },
  data() {
    const { merchant, branch } = JSON.parse(localStorage.getItem('userData'))
    const { branch_slot, user_slot } = merchant
    const { uuid: branch_uuid, renewal_end_date, is_main_branch, renewal_status, subscription_credit } = branch
    return {
      currentPage: 1,
      branch_total_registered: 0,
      branch_slot,
      user_slot,
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "No. Invoice",
          field: "invoice_number",
        },
        {
          label: "Jumlah",
          field: "subscription_renewal.sell_price",
        },
        {
          label: "Jenis Paket",
          field: "subscription_renewal.renewal_name",
        },
        {
          label: "Metode Bayar",
          field: "payment_method",
        },
        {
          label: "Berlaku Hingga",
          field: "payment_expired_at",
        },
        {
          label: "Status",
          field: "payment_status",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      rows: {},
      items: [],
      search: "",
      result: {},
      filter: {
        search: "",
        sort_type: "asc",
        per_page: 10,
      },
      isLoading: false,
      subscriptionMethod: '',
      selectedPayment: "",
      paymentList: [],
      minimumTopupCredit: 0,
      transactionFee: 0,
      optionsBranch: [],
      titleDetailInformation: {
        fix_plan: 'Toqoo Fix Plan',
        flex_plan: 'Toqoo Flex Plan'
      },
      typeExtend: '',
      money: {
        decimal: "",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      creditSubscriptionPayload: {
        amount: 0,
        payment_provider_name: 'xendit',
        payment_method: '',
        receiver_type: 'branch',
        receiver_uuid: ''
      },
      isMainAccount: is_main_branch,
      mainBranchUuid: branch_uuid,
      renewalEndDate: renewal_end_date,
      renewalStatus: renewal_status,
      subscriptionCredit: subscription_credit
    };
  },
  watch: {
    result(value) {
      this.rows = value;
      this.items = value.data.data;
    },
    filter: {
      handler(value) {
        this.$emit("filter", value);
      },
      deep: true,
    },
    filter: {
      handler: _.debounce(function () {
        this.getListSubscription();
      }, 300),
      deep: true,
    },
  },
  created() {
    this.getListSubscription();
  },
  mounted() {
    this.handleCta()
    this.getPaymentMethod()
    this.getBranch()
    
    this.$http.get('/settings')
    .then((result) => {
      this.minimumTopupCredit = result.data.data.credit_subscription_minimum_amount 
      this.transactionFee = result.data.data.credit_subscription_transaction_fee
    }).catch((err) => {
      
    });
  },
  methods: {
    extendMainStoreSubscription() {
      this.clearCreditProperty()
      this.$bvModal.show('modal-subscription-method')
    },
    clearCreditProperty() {
      this.subscriptionMethod = ''
      this.typeExtend = ''
      this.creditSubscriptionPayload = {
        amount: 0,
        payment_provider_name: 'xendit',
        payment_method: '',
        receiver_type: 'branch',
        receiver_uuid: ''
      }
    },
    addOrExtend(type) {
      this.clearCreditProperty()
      this.typeExtend = type
      if (type === 'branch') {
        this.$bvModal.show('modal-subscription-method')
      }
      if (type === 'user') {
        this.$bvModal.show('modal-billing-subscription')
      }
    },
    submit(type) {
      this.subscriptionMethod = type
      if (type === 'flex_plan') {
        this.$bvModal.show('modal-detail-information')
      }
      if (type === 'fix_plan') {
        if (this.typeExtend === 'branch') {
          this.$bvModal.show('modal-billing-subscription')
        } else {
          this.$bvModal.show('modal-subscribe')
        }
      }
    },
    async getPaymentMethod() {
      try {
        const response = await this.$http.get('/available-payment-methods')
        this.paymentList = response.data.data.map((item) => {
          return {
            name: item.payment_name,
            value: item.payment_code,
            image: item.logo_url,
          }
        })
      } catch (error) {
        
      }
    },
    submitSubscriptionMethod() {
      const statusSubscribe = {
        flex_plan: 'subscribe-flex-plan',
        fix_plan: 'subscribe'
      }
      const userData = JSON.parse(localStorage.getItem('userData'))
      const branch = userData.branch
      const renewalStatus = this.creditSubscriptionPayload.receiver_uuid && this.creditSubscriptionPayload.receiver_uuid.renewal_status || branch.renewal_status
      const renewalEndDate = this.creditSubscriptionPayload.receiver_uuid && this.creditSubscriptionPayload.receiver_uuid.renewal_end_date || branch.renewal_end_date
      const subscriptionCredit = this.creditSubscriptionPayload.receiver_uuid && this.creditSubscriptionPayload.receiver_uuid.subscription_credit || branch.subscription_credit
      if (statusSubscribe[this.subscriptionMethod] !== renewalStatus) {
        this.$swal({
          title: `Saat ini Anda masih memiliki langganan ${renewalStatus === 'subscribe-flex-plan' ? 'Toqoo Flex Plan' : 'Toqoo Fix Plan'} dengan ${renewalStatus === 'subscribe-flex-plan' ? 'credit sebesar ' + subscriptionCredit + ' Transaksi' : 'masa aktif sampai ' + renewalEndDate}`,
          text: `Jika proses pembayaran ini dilanjutkan, maka masa aktif Anda di ${renewalStatus === 'subscribe-flex-plan' ? 'Toqoo Flex Plan' : 'Toqoo Fix Plan'} akan hangus dan metode berlangganan Anda berubah menjadi ${renewalStatus === 'subscribe-flex-plan' ? 'Toqoo Fix Plan' : 'Toqoo Flex Plan'}. \nApakah Anda yakin ingin melanjutkan proses pembayaran ini?`,
          icon: 'warning',
          showCancelButton: true,
          width: 600,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
            title: 'text-danger size16 font-weight-bolder'
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.postSubscription()
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.postSubscription()
      }
    },
    postSubscription() {
      this.isLoading = true
      const payload = this.preparePayload()
      this.$http.post('/subscription-credit-payments', payload).then((result) => {
        const uuid = result.data.data.uuid;
        this.isLoading = false
        this.$router.push({
          name: 'credit_subscription.detail',
          params: { id: uuid },
        });
      }).catch((err) => {
        this.isLoading = false
        console.log(err);
      });
    },
    preparePayload() {
      const form = new FormData();
      // isMainAccount
      // mainBranchUuid
      const payload = {
        ...this.creditSubscriptionPayload,
        receiver_uuid: this.isMainAccount && !this.creditSubscriptionPayload.receiver_uuid ? this.mainBranchUuid : this.creditSubscriptionPayload.receiver_uuid?.uuid,
        amount: this.creditSubscriptionPayload.amount / parseFloat(this.transactionFee)
      };
      for (const key in payload) {
        if (payload.hasOwnProperty(key) && payload[key] != null) {
          form.append(key, payload[key]);
        }
      }

      return form;
    },
    prevSubmitSubscriptionMethod() {
      this.$bvModal.hide('modal-detail-information')
    },
    getBranch() {
      this.$store
        .dispatch('cabang/getData', { uuid: '', params: '' })
        .then((result) => {
          this.optionsBranch = result.data.data.data
          .filter((e) => !e.is_main_branch)
          .map((e) => {
            return {
              uuid: e.uuid,
              name: e.name,
              renewal_end_date: e.renewal_end_date,
              renewal_status: e.renewal_status,
              subscription_credit: e.subscription_credit
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearchBranch(search, loading) {
      if (search.length) {
        loading(true);
        this.searchBranch(loading, search, this);
      } else {
        loading(true);
        setTimeout(() => {
          this.optionsUser = [];
          this.getUser();
          loading(false);
        }, 500);
      }
    },
    searchBranch: _.debounce((loading, search, vm) => {
      vm.$store
        .dispatch('cabang/getData', {
          uuid: '',
          params: {
            search,
          },
        })
        .then((response) => {
          vm.optionsBranch = response.data.data.data
          .filter((e) => !e.is_main_branch)
          .map((e) => {
            return {
              uuid: e.uuid,
              name: e.name,
              renewal_end_date: e.renewal_end_date,
              renewal_status: e.renewal_status,
              subscription_credit: e.subscription_credit
            };
          });
          loading(false);
        })
        .catch((error) => {
          loading(false);
        });
    }, 300),
    handleCta() {
      const { cta } = this.$route.query
      if (cta) {
        setTimeout(() => {
          this.$bvModal.show(cta)
        }, 500);
      }
    },
    getFilter(value) {
      this.filter = value;
    },
    async getListSubscription(page = 1) {
      this.isLoading = true;
      const queryParams = this.filter;
      queryParams.page = page;
      this.$store
        .dispatch("subscribe/getListSubscription", { params: queryParams })
        .then((result) => {
          this.result = result.data;
          this.currentPage = result.data.data.current_page;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    detailItem(row) {
      const uuid = row.uuid;

      this.$router.push({
        name: 'billing.index',
        params: { id: uuid },
      });
    },
    cancelOrder(id) {
      this.$swal({
        title: "Konfirmasi",
        text: "Apa Anda yakin ingin membatalkan transaksi berlangganan ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("subscribe/deleteData", {
              uuid: `${id}`,
            })
            .then(() => {
              this.isLoading = false;
              this.$swal({
                icon: "success",
                title: "Success!",
                text: "Order berhasil dibatalkan",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.getListSubscription();
            })
            .catch((err) => {
              this.isLoading = false;
              // eslint-disable-next-line no-console
              console.log(err);
            });
        }
      });
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.vgt-responsive {
  height: calc(100vh - 235px) !important;
  background-color: #fff;
}
</style>